


















import vue from "vue";
import ReleaseNoteCard from "./ReleaseNoteCard.vue";
import {
  ReleaseNotesActionNames,
  ReleaseNotesGetterNames,
  ReleaseNotesNamespace
} from "@tt-app/types/releaseNotes/store";
import { ReleaseNotes } from "@tt-app/api/releaseNotes";

interface Methods {
  fetchReleaseNotes: () => void;
}

interface Computed {
  releaseNotes: ReleaseNotes[];
  isLoading: boolean;
  noResults: boolean;
}

export default vue.extend<Record<any, any>, Methods, Computed, Record<any, any>>({
  name: "ReleaseNotes",
  components: { ReleaseNoteCard },
  created() {
    this.fetchReleaseNotes();
  },
  methods: {
    fetchReleaseNotes() {
      this.$store.dispatch(
        `${ReleaseNotesNamespace}/${ReleaseNotesActionNames.REQUEST_RELEASE_NOTES}`
      );
    }
  },
  computed: {
    releaseNotes() {
      return this.$store.getters[
        `${ReleaseNotesNamespace}/${ReleaseNotesGetterNames.RELEASE_NOTES}`
      ];
    },
    isLoading() {
      return this.$store.getters[`${ReleaseNotesNamespace}/${ReleaseNotesGetterNames.IS_LOADING}`];
    },
    noResults() {
      const hasReleaseNotes = this.releaseNotes?.length > 0;
      return !hasReleaseNotes && !this.isLoading;
    }
  }
});
